import api from "../api";
const _imgCache = new Map();

const getRoomImage = async (imageUID) => {
  if (!imageUID) return null;
  if (_imgCache.has(imageUID)) return _imgCache.get(imageUID);

  const url = `${process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT}/app/auth/banner/${imageUID}`;
  try {
    const res = await api.get(url, { responseType: "arraybuffer" });
    const blob = new Blob([res.data], { type: "image/jpeg" });
    const objUrl = URL.createObjectURL(blob);
    _imgCache.set(imageUID, objUrl);
    return objUrl;
  } catch (e) {
    console.error("getRoomImage failed:", e);
    return null;
  }
};

export default getRoomImage;
